import * as Yup from 'yup';
import { v4 as uuidV4 } from 'uuid';
import { IColdStorage } from './coldStorage';
import { IColdStorageFormValues } from './coldStorageFormValues';
import { IColdStorageUpsert } from './coldStorageUpsert';
import moment from 'moment';
import { IStorageUnit } from '../masterData/storageUnit/storageUnit';
import OptionType from '../optionType';
import { IOptionType } from '@zz2/zz2-ui';

export default class ColdStorageModelHelper {
    public static createFormValues = (
        coldStorage : IColdStorage | null,
        storageUnits : Array<IStorageUnit>,
        defaultStorageUnit : IStorageUnit | null
    ) : IColdStorageFormValues => {
        if (!coldStorage) return {
            id: 0,
            guid: uuidV4(),
            startedOn: moment().local(),
            expectedRunTimeHours: 0,
            storageUnit: defaultStorageUnit
                ? OptionType.fromDataModel(defaultStorageUnit)
                : null,
            endedOn: null,
            isActive: true,
        };

        const storageUnit = storageUnits.find(x => x.id === coldStorage.storageUnitId);

        return {
            id: coldStorage.id,
            guid: coldStorage.guid,
            startedOn: moment.utc(coldStorage.startedOn).local(),
            expectedRunTimeHours: coldStorage.expectedRunTimeSeconds / 3600,
            storageUnit: storageUnit
                ? OptionType.fromDataModel(storageUnit)
                : null,
            endedOn: coldStorage.endedOn
                ? moment.utc(coldStorage.endedOn).local()
                : null,
            isActive: coldStorage.isActive,
        };
    };

    public static createUpsert = (formValues : IColdStorageFormValues) : IColdStorageUpsert => {
        return {
            id: formValues.id,
            guid: formValues.guid,
            startedOn: formValues.startedOn,
            expectedRunTimeSeconds: formValues.expectedRunTimeHours * 3600,
            storageUnitId: Number(formValues.storageUnit?.value ?? 0),
            endedOn: formValues.endedOn,
            isActive: formValues.isActive,
        };
    };

    public static formSchema = () : Yup.ObjectSchema<IColdStorageFormValues> => Yup.object().shape({
        id: Yup.number().typeError('Please enter a number.').required('Required'),
        guid: Yup.string().required('Required'),
        startedOn: Yup.mixed<moment.Moment>().required('Required'),
        endedOn: Yup.mixed<moment.Moment>().required('Required')
            .when('startedOn', (startedOn) => {
                return Yup.date()
                    .typeError('Enter a valid end date or leave the field empty')
                    .nullable()
                    .min(startedOn, 'End date cannot be before start date.');
            }),
        expectedRunTimeHours: Yup.number().positive('Must be a positive number').typeError('Please enter a number.').required('Required'),
        storageUnit: Yup.mixed<IOptionType>().defined().nullable().required('Required'),
        isActive: Yup.boolean().required('Required'),
    });
}
